import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EnvironmentService } from "../services/environment.service";
import { IOwnerResponse } from "../models/owner.model";

@Injectable({
	providedIn: "root"
})
export class OwnerApiService {
	constructor(private environmentService: EnvironmentService, private httpClient: HttpClient) {}

	getOwner(id: string, fields: string[]): Observable<IOwnerResponse> {
		let httpParams = new HttpParams();
		if (fields.length) httpParams = httpParams.set("fields", fields.join(","));

		return this.httpClient.get<IOwnerResponse>(`${this.environmentService.apiUrl}/owner/${id}`, { params: httpParams });
	}
}
